import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getInterestRateImageSettings() {
    return RetailerApiClient.get('/base-interest-rates/get-price-comparison-image-settings')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
